import React, { useContext } from "react";
import { Td, Tooltip, Tr } from "@chakra-ui/react";
import { BsEyeFill } from "react-icons/bs";
import { IconGeneric } from "styled/Icons.styled";
import MenuTesoreria from "components/Menu/MenuTreasury/MainMenuTreasury";
import TreasuryCrudContex from "context/TreasuryContex";

const TBodySpecialRate = ({ data }) => {
  const { setDataIdShow, onOpenViewUpdate } = useContext(TreasuryCrudContex);
  // console.log(data);
  const DataIdShow = () => {
    setDataIdShow(data);
    onOpenViewUpdate();
  };

  return (
    <>
      <Tr>
        <Td className="text-center">{data?.nit_qualified}</Td>
        <Td className="text-center">{data?.name_qualified}</Td>
        <Td className="text-center">{data?.date_rate}</Td>
        <Td className="text-center">{data?.name_type_rate}</Td>
        <Tooltip placement="top" hasArrow label={"Ver más"}>
          <Td className="text-center">
            <IconGeneric
              color={"#1F7AC3"}
              as={BsEyeFill}
              onClick={DataIdShow}
            />
          </Td>
        </Tooltip>
        <Td className="text-center" isNumeric>
          <MenuTesoreria data={data} />
        </Td>
      </Tr>
    </>
  );
};

export default TBodySpecialRate;
